// extracted by mini-css-extract-plugin
export var active = "_9j-d";
export var blink = "_9j-e";
export var container = "_9j-5";
export var controls = "_9j-0";
export var controlsRight = "_9j-1";
export var fakeCursor = "_9j-c";
export var hidden = "_9j-b";
export var quillContainerSmall = "_9j-7";
export var quillEditor = "_9j-6";
export var quillEditorSmall = "_9j-8";
export var quillFormatButtons = "_9j-a";
export var quillToolbar = "_9j-9";
export var removePadding = "_9j-2";
export var state = "_9j-3";
export var stateTitle = "_9j-4";